import React from 'react';

export const Work = () => {
  return (
    <>
      <div className="help private-help" id='prod-start' style={style}>
        <div className="container">
            <div className="row">
                <h2>Let's Work Together</h2>
                <p><span>Do you have a specific product in mind, colors or ingredient?</span> <br /> Our team loves a good challenge ﻿so send us your ideas and we’d be happy to work with you.</p>
                <a href='/contact' className="btn btn-primary">Contact Us</a>
            </div>
        </div>
      </div>
    </>
  );
};

const style = {
    'backgroundColor': "#f2f2f2",
    "marginTop": "-3px"
};
